// フッター内のリンクコンテンツの非同期読み込み（作品&作品グループページのみ）
const $commonLinks = $('#js-common-links');

const createCommonLinks = () => {
  fetch('/api/common_links.html', {
    method: 'GET',
    headers: {
      'Content-Type': 'text/html; charset=utf-8',
      'X-Requested-With': 'XMLHttpRequest',
    }
  }).then((res) => {
    return res.text();
  }).then((data) => {
    // add list html
    $commonLinks.append(data);
  }).catch((res) => {
    console.log(res);
  });
}

if($commonLinks.length > 0) {
  createCommonLinks();
}